// extracted by mini-css-extract-plugin
export default {"page404":"page404-3fd8"};